import Api from './api';

export const getByOrganizationCategoryId = async (organizationCategoryId) => {
  let data = [];
  await Api.get(`/organizationfieldscategory/by-category/${organizationCategoryId}`)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};

export const updateOrder = async (organizationCategoryId, items, updatedUser) => {
  let data = [];
  const payload = {
    organizationCategoryId: organizationCategoryId,
    items: items,
    updatedUser: updatedUser
  };

  await Api.put('/organizationfieldscategory/update-order', payload)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = err;
    });
  return data;
};
